import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import { Helmet } from 'react-helmet/es/Helmet'
import PageTitle from '../../components/PageTitle'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { inject, observer } from 'mobx-react'
import { systemName } from '../../config'
import MySalaryVpList from './MySalaryVpList'

const MySalaryVpPage = props => {
  const { salaryVpStore } = props

  useEffect(() => {
    return () => {
      salaryVpStore.clearMySalaryVpList()
    }
  }, [salaryVpStore])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Lương của tôi | {systemName} Portal</title>
      </Helmet>
      <PageTitle 
        title="Lương của tôi"
        showTitle={true}
        location={props.location} 
      />
      <ContentBlockWrapper style={{ minHeight: 'calc(100vh - 150px)' }}>
        <MySalaryVpList />
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

export default inject('salaryVpStore')(observer(MySalaryVpPage))
